import { render, staticRenderFns } from "./CashbackResultModal.vue?vue&type=template&id=f6bf7e36&"
import script from "./CashbackResultModal.vue?vue&type=script&lang=js&"
export * from "./CashbackResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports